import { ListItem, type ListItemProps, type SxProps } from '@mui/material';
import { m, type AnimationProps, type TapHandlers } from 'framer-motion';
import { forwardRef } from 'react';

const MotionListItem = m(
  forwardRef(
    function MyListItem(props: ListItemProps, ref: React.ForwardedRef<HTMLLIElement>) {
      return (
        <ListItem {...props} ref={ref}/>
      );
    }
  )
);

interface MenuItemProps extends AnimationProps, TapHandlers {
  children: React.ReactNode;
  sx: SxProps;
}

export const MenuItem: React.FC<MenuItemProps> = ( { children, ...props } ) => (
  <MotionListItem
    {...props}
  >
    {children}
  </MotionListItem>
);
